import React from 'react';
import { Box, Typography, Grid, CircularProgress, Alert } from '@mui/material';
import ProcedureRequestCard from '../ProcedureRequestCard/ProcedureRequestCard';
import PropTypes from 'prop-types';

const ProcedureRequestList = ({ 
  procedureRequests = [], 
  loading = false, 
  error = null, 
  onSelectProcedureRequest, 
  onClaimProcedureRequest, 
  onIssueProcedureRequest,
  isClaimed = false,
  isIssued = false,
  emptyMessage = "No procedure requests found" 
}) => {
  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Alert severity="error" sx={{ mb: 2 }}>
        {error}
      </Alert>
    );
  }

  if (!procedureRequests || procedureRequests.length === 0) {
    return (
      <Box sx={{ p: 4, textAlign: 'center' }}>
        <Typography variant="body1" color="text.secondary">
          {emptyMessage}
        </Typography>
      </Box>
    );
  }

  return (
    <Grid container spacing={3}>
      {procedureRequests.map((procedureRequest) => (
        <Grid item xs={12} sm={6} md={4} key={procedureRequest.requestId}>
          <ProcedureRequestCard 
            procedureRequest={procedureRequest}
            onSelect={() => onSelectProcedureRequest && onSelectProcedureRequest(procedureRequest)}
            onClaim={() => onClaimProcedureRequest && onClaimProcedureRequest(procedureRequest.requestId)}
            onIssue={() => onIssueProcedureRequest && onIssueProcedureRequest(procedureRequest.requestId)}
            isClaimed={isClaimed}
            isIssued={isIssued}
          />
        </Grid>
      ))}
    </Grid>
  );
};

ProcedureRequestList.propTypes = {
  procedureRequests: PropTypes.array.isRequired,
  onSelectProcedureRequest: PropTypes.func,
  onClaimProcedureRequest: PropTypes.func,
  onIssueProcedureRequest: PropTypes.func,
  isClaimed: PropTypes.bool,
  isIssued: PropTypes.bool,
  emptyMessage: PropTypes.string
};

ProcedureRequestList.defaultProps = {
  emptyMessage: 'No procedure requests found'
};

export default ProcedureRequestList; 